
<script>
import { mapGetters } from 'vuex'
import cardStyle from '@/assets/images/icons/card-style.svg?inline'
import tableStyle from '@/assets/images/icons/table-style.svg?inline'
import mapStyle from '@/assets/images/icons/location.svg?inline'
import sortOrder from '@/assets/images/icons/sort.svg?inline'
import UserSetting from '@/utils/userSetting'
import {
  RexCheckbox
} from '@/components/views/rexFieldsV2'

export default {
  name: 'search-controls',
  components: {
    cardStyle,
    tableStyle,
    sortOrder,
    mapStyle,
    RexCheckbox
  },
  props: {
    storeModule: {
      type: String,
      default: () => null,
      required: true
    },
    getterFieldName: {
      type: String,
      required: true
    },
    setterFieldName: {
      type: String,
      required: true
    },
    hideAgentPriceToggler: {
      type: Boolean,
      default: () => false
    },
    hideViewTypeChanger: {
      type: Boolean,
      default: () => false
    },
    isLoading: {
      type: Boolean,
      default: () => false
    },
    isSortBlocked: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    agentPrice: {
      get() {
        return this.$store.getters[`${this.storeModule}/${this.getterFieldName}`]('agentPrice')
      },
      set(value) {
        this.$store.commit(`${this.storeModule}/${this.setterFieldName}`, {
          target: 'agentPrice',
          value
        })
      }
    },
    viewType: {
      get() {
        return this.$store.getters[`${this.storeModule}/${this.getterFieldName}`]('viewType')
      },
      set(value) {
        this.$store.commit(`${this.storeModule}/${this.setterFieldName}`, {
          target: 'viewType',
          value
        })

        UserSetting.setViewType(value)
      }
    },
    sortOrder: {
      get() {
        return this.$store.getters[`${this.storeModule}/${this.getterFieldName}`]('form.priceSort')
      },
      set(value) {
        this.$store.commit(`${this.storeModule}/${this.setterFieldName}`, {
          target: 'form.priceSort',
          value
        })

        this.$emit('sort', value)
      }
    },
    ...mapGetters('account', [
      'checkAgencyPriceAccess'
    ])
  },
  methods: {
    updateViewType(type) {
      this.activeViewType = type
    },
    changeSortOrder() {
      if (this.isSortBlocked) {
        this.$buefy.snackbar.open({
          message: 'Сначала примените фильтры.',
          type: 'is-danger',
          position: 'is-top-right',
          actionText: 'ПРИМЕНИТЬ',
          duration: 10000,
          onAction: () => {
            this.$emit('filter')
          }
        })
      } else {
        this.sortOrder = this.sortOrder === 'ascending'
          ? 'descending'
          : 'ascending'
      }
    },
  }
}
</script>

<template>
  <div class="search-controls">
    <div class="search-controls__item">
      <template
        v-if="!hideViewTypeChanger"
      >
        <button
          class="search-controls__view-type"
          :class="{ active: viewType === 'map'}"
          :disabled="isLoading"
          @click="viewType = 'map'"
        >
          <map-style />
          <p>На карте</p>
        </button>
        <button
          class="search-controls__view-type"
          :class="{ active: viewType === 'card'}"
          :disabled="isLoading"
          @click="viewType = 'card'"
        >
          <card-style />
          <p>Карточки</p>
        </button>
        <button
          class="search-controls__view-type"
          :class="{ active: viewType === 'table'}"
          :disabled="isLoading"
          @click="viewType = 'table'"
        >
          <table-style />
          <p>Таблица</p>
        </button>
      </template>
    </div>
    <div class="search-controls__item">
      <button
        class="search-controls__sorting"
        :class="{
          'search-controls__sorting--no-margin': hideAgentPriceToggler,
          'search-controls__sorting--blocked': isSortBlocked
        }"
        :disabled="isLoading"
        @click="changeSortOrder"
      >
        <sort-order
          class="search-controls__sorting-icon"
          :class="{
            'search-controls__sorting-icon--reverse': sortOrder === 'ascending'
          }"
        />
        По цене
      </button>
      <rex-checkbox
        v-if="!hideAgentPriceToggler && !checkAgencyPriceAccess"
        name="searchControlsAgencyPriceTrigger"
        :store-module="storeModule"
        :getter="getterFieldName"
        :setter="setterFieldName"
        target="agencyPrice"
        :is-disabled="isLoading"
        checkbox-label="Цена агента"
      />
    </div>
  </div>
</template>